import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '2x',
  padding: '2x',
  marginTop: '4x',
  backgroundColor: 'hpxGrey100',
  borderRadius: '8px',
});

export const textContent = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const cuckooIcon = css({
  width: '32px',
  height: '32px',
});

export const messageText = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxBlue600',
});

export const exploreLink = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxTeal500',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  textAlign: 'left',
  textDecoration: 'underline',
  _hover: {
    color: 'hpxTeal600',
  },
});
